import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import * as CurrentUserSelectors from './../../../app/@store/current-user/current-user.selectors';
import { filter, map, take, distinctUntilChanged } from 'rxjs/operators';

type UserRole = 'admin' | 'write' | 'read';
@Injectable({
  providedIn: 'root'
})
export class UserRoleService {
  role$: BehaviorSubject<{ user_role: UserRole }> = new BehaviorSubject({ user_role: 'read' as UserRole });

  constructor(private store: Store) {
    this.store
      .select(CurrentUserSelectors.user)
      .pipe(
        filter(_user => _user?.partner_role !== undefined),
        take(1)
      )
      .subscribe(_user => {
        this.role$.next({ user_role: _user!.partner_role! });
      });
  }

  isAdmin$() {
    return this.role$.pipe(
      distinctUntilChanged(),
      map(role => role?.user_role === 'admin')
    );
  }

  isWrite$(_explicit = false) {
    return this.role$.pipe(
      distinctUntilChanged(),
      map(role => {
        if (_explicit) {
          return role.user_role === 'write';
        }

        return role.user_role === 'write' || role.user_role === 'admin';
      })
    );
  }

  isRead$() {
    return this.role$.pipe(
      distinctUntilChanged(),
      map(role => role?.user_role === 'read')
    );
  }

}
